import { createRouter, createWebHistory } from "vue-router";

import { FrontpageRouter } from "./routes/Frontpage"; // 前台
const public_routes = [
  {
    // 空页面 路由加载缓冲区
    path: "/loading",
    name: "loading",
    component: () => import("@/views/NULLROUTER"),
    meta: {
      affiliation_Left: "loading", // 归属级 (左侧的)
    },
  },
  {
    path: "/loginWrapt",
    name: "loginWrapt",
    component: () => import("../views/login/index.vue"),
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("../views/login/login/index.vue"),
      },
      {
        path: "/qrlogin",
        name: "qrlogin",
        component: () => import("../views/login/qrLogin/index.vue"),
      },
    ],
  },
  // 个人信息
  {
    path: "/wenxiang/userInfo",
    menuId: "userInfo",
    name: "userInfo",
    component: () => import("@/views/front/userInfo"),
    meta: {
      mark: 'homedatacrx',
      transparency_Head: true,
      skip_login: true, // 免登录 设置为true
      affiliation_Head: "dataAnalysisReport", // 归属级 (头部的)
      affiliation_Left: "dataAnalysisReport", // 归属级 (左侧的)
    },
  },
  {
    path: "/activation",
    name: "activation",
    component: () => import("../views/activation/index.vue"),
    children: [],
  },
  {
    path: "/extendAuthorization",
    name: "extendAuthorization",
    component: () => import("../views/extendAuthorization/index.vue"),
    children: [],
  },
  {
    path: "/awaitPage",
    name: "awaitPage",
    component: () => import("../views/awaitPage/index.vue"),
    children: [],
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/register/index.vue"),
    children: [
      {
        path: "/register",
        name: "register",
        component: () => import("../views/register/register/index.vue"),
      },
      {
        path: "/qrRegister",
        name: "qrRegister",
        component: () => import("../views/register/qrRegister/index.vue"),
      },
    ],
  },
  {
    // 实时巡课  分享详情页
    path: "/SCADA/ShareDetail",
    name: "SCADA_ShareDetail",
    component: () => import("@/views/front/supervisor/SCADA/detailVideo"),
  },
];
// 整合路由
const routes = [...public_routes, ...FrontpageRouter];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
